import React from 'react'
import PropTypes from 'prop-types'
import { Rating } from '@sainsburys-tech/fable'

const Ratings = ({ onClickHandler, overallRating, reviewCount }) => {
  return (
    <button type='button' data-testid='reviews-flag' onClick={onClickHandler}>
      <Rating rating={overallRating} itemProp='aggregateRating' itemType='https://schema.org/AggregateRating' itemScope>
        <span
          className='before:ds-content-["("] after:ds-content-[")"]'
          onClick={onClickHandler}
          data-testid='reviews-flag-link'
          itemProp='reviewCount'
        >
          {reviewCount}
        </span>
        <meta itemProp='ratingValue' content={overallRating} />
        <meta itemProp='worstRating' content='1' />
        <meta itemProp='bestRating' content='5' />
      </Rating>
    </button>
  )
}
export default Ratings

Ratings.propTypes = {
  onClickHandler: PropTypes.func.isRequired,
  overallRating: PropTypes.number.isRequired,
  reviewCount: PropTypes.number.isRequired
}
